import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const useSlotSettings = () => {
  const [slotCapacity, setSlotCapacity] = useState(6); // Default fallback
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlotSettings = async () => {
      try {
        const response = await axios.get(`${API}/slots/settings`);
        setSlotCapacity(response.data.slot_capacity || 6);
      } catch (error) {
        console.error('Error fetching slot settings:', error);
        // Keep default value on error
      } finally {
        setLoading(false);
      }
    };

    fetchSlotSettings();
  }, []);

  return { slotCapacity, loading };
};
